import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Container from 'react-bootstrap/Container';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import CardColumns from 'react-bootstrap/CardColumns';
import Image from 'react-bootstrap/Image'
import heroForegroundImage from '../../assets/header_content.png';
import {
  HashLink as Link
} from "react-router-hash-link";
import aboutPicture from '../../assets/about.jpg';

import sponsorImageFlyingClipper from '../../assets/flying_clipper_logo.jpg';
import sponsorImageHop from '../../assets/home_of_poi_logo.jpg';
import sponsorImageHauntedWalk from '../../assets/haunted_walk.jpg';
import sponsorImageShivas from '../../assets/shivaslogo.jpg';
import sponsorImageJolly from '../../assets/jolly.jpg';
import sponsorImageFlowtoys from '../../assets/flowtoys.png';

function HeroSection() {
  return <Jumbotron fluid className="min-vh-100 jumbotron-background-image m-0 d-flex flex-column justify-content-center bg-dark" id="home">
    <Container className="d-flex flex-column h-100 justify-content-center pb-2 align-items-center">
      <Image src={heroForegroundImage} className="mt-3" fluid />
      <h3 className="text-light mb-3 font-weight-light mt-5 text-center">Limestone City Juggling Festival</h3>
      <Link smooth className="btn btn-outline-light btn-lg" to='/#about'>Learn more</Link>
    </Container>
  </Jumbotron>
}

function AboutSection() {
  return <section className="m-0 min-vh-100 pt-5" id="about">
    <Container>
      <h2 className="display-2 text-left">About</h2>
      <p className="py-3">The Kingston Jugglers’ Club has been throwing and catching balls, rings, clubs, and more since 1992. With its vibrant arts and culture scene and new live arts festivals emerging every year, we knew Kingston would be the perfect home for an annual juggling festival. So, in 2014, we teamed up with the Queen’s University Jugglers’ Club to bring you the Limestone City Juggling Festival - a party for people who like to toss, catch, spin, balance, twirl, or otherwise manipulate objects! Juggling clubs hold festivals around the world and Kingston’s is one of three in Ontario - next to Guelph and Waterloo.</p>
      <p className="py-3">The Limestone City Juggling Festival is free to attend and family-friendly. This year’s festival will be held on the weekend of October 25-27th, 2019 at the John Deutsch University Centre on Queen’s campus. All skill levels are welcome! At the festival there will be juggling workshops for beginners and experts alike, juggling games and competitions to participate in or watch, and vendors to sell you your first set of juggling balls. On Saturday night we will host a spectacular juggling and circus show with a unique variety of world-class performers you won’t want to miss!</p>
      <div style={{position: 'relative'}}>
        <Image src={aboutPicture} className="mt-3" fluid />
        <div className="picture-overlay"></div>
      </div>
    </Container>
  </section>
}

function FaqsSection(props) {
  return <section className="m-0 min-vh-100 pt-5" id="faq">
    <Container>
      <h2 className="display-2 text-left">Frequently Asked Questions</h2>
      <Accordion defaultActiveKey="-1" className="d-flex flex-column align-items-stretch mt-3 justify-content-between" bsPrefix="faq-accordion">
        { props.faqs.map( ({question, answer}, idx) => (
          <Card className="mb-3" key={`faq-${idx}`}>
            <Accordion.Toggle as={Card.Header} eventKey={`${idx}`} className="lead bg-secondary text-light">
              { question } <span className="small d-block d-md-inline" style={{opacity: 0.4}}>(click to expand/collapse)</span>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={`${idx}`}>
              <Card.Body dangerouslySetInnerHTML={{__html:answer}}></Card.Body>
            </Accordion.Collapse>
          </Card>
        ))
        }
      </Accordion>
    </Container>
  </section>
}

function RenegadeShowSection(props) {
  return <section fluid className="bg-dark text-light m-0 min-vh-100 pt-5" id="about">
    <Container>
      <h2 className="display-2 text-left">Renegade</h2>
      <p className="p-3">We are excited to announce that for the first time ever, the Limestone City Juggling Festival is hosting a Renegade show! This is a late night, adults only curated open stage show featuring variety acts that are hilarious, awesome, and short. The Renegade show will feature riotous stand-up comedy, risky juggling, risque unicycling, and SO MUCH MORE! If you’ve never been to a Renegade - you need to experience it! Entry is pay-what-you-can and any money made on the event goes back to the performers.</p>
      <p className="p-3">Do you think you have a short, awesome, funny, sexy, or plain old weird act you want to perform? Send an email to the show director. Link to open mail to fest@kingstonjugglers.club</p>
    </Container>
  </section>
}

function EventsSchedule({
  schedule
}) {
  return <div>
    {
      schedule.map(({ day, events }, idx) => {
        return <Row className="mb-5" key={'schedule-'+idx}>
          <Col md="12" className="mb-2">
            <h4 className="font-weight-light">{ day }</h4>
          </Col>
          {
            events.map(({time, event}, idx) => (
              <React.Fragment key={'event-' + idx}>
                <Col md="2" className="lead font-weight-bold text-primary my-2">{time}</Col>
                <Col md="10" className="lead my-2">{event}</Col>
              </React.Fragment>
            ))
          }
        </Row>
      })
    }
  </div>
}

function Locations() {
  return <Row className="mt-5">
    <Col md="12" className="mb-3">
      <h4>Festival Headquarters and Main Gym</h4>
      <p className="lead mb-0">Wallace Hall of the John Deutsch University Centre</p>
      <p >87 Union Street West</p>
      <p className="font-weight-bold mt-3 mb-0">Workshop space</p>
      <p className="lead">McClaughlin Room of the John Deutsch University Centre</p>
      <div className="embed-responsive embed-responsive-16by9">
        <iframe className="embed-responsive-item" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1429.4799056218599!2d-76.49576464179208!3d44.228485794776496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cd2ab040df43553%3A0x13e4219bdbf13b60!2sJohn%20Deutsch%20University%20Centre!5e0!3m2!1sen!2sca!4v1568011235434!5m2!1sen!2sca" allowFullScreen=""></iframe>
      </div>
    </Col>
  </Row>
}

function Accomodations({
  accomodations
}) {
  return <div>
    <h4>Accomodations</h4> <
      p > Downtown Kingston has many beautiful inns, hotels, and bed and breakfasts that are walking distance to the juggling festival.Here are some options, but there are many more around: </p> {
        accomodations.map(({
          category,
          locations
        }, idx) => {
          return <React.Fragment key={'accomodations-' + idx}>
            <p className="font-weight-bold text-secondary">{category}</p>
            <ul>
              { locations.map(({name, website}, idx) => <li key={'location' + idx}><a href={website}>{ name }</a></li>) }
            </ul>
          </React.Fragment>
        })
      }
      <p>There are also some air bnbs near the festival location.</p> <
        p > If you are a juggler coming in from out of town and looking
        for crash space, we have a limited amount of couch and floor space available. < a href = "mailto:bdfl@kingstonjugglers.club" > Contact Greg and we will
        try to set you up. < /a></p >
      </div>
}

function Games({
  games
}) {
  return <div>
    <h4>Games</h4> < p > This year’ s juggling games and competitions will include: </p> <
      ul > {
        games.map((game, idx) => <li key={'game' + idx}>{game}</li>)
      }
    </ul> <
      p > Start training now
      for your chance to win an awesome prize and bragging rights!</p>
    </div>
}

function Workshops() {
  return <div>
    <h4>Workshops</h4> 
    <p className = "text-muted" > <a href="https://docs.google.com/spreadsheets/d/1w8WStVTLX5EnoP98Czf7OrPjKpn_W2E_-F26UxM4rsQ/edit?usp=sharing">Click here</a> to see the workshop schedule. We will also have beginner juggling lessons on demand
      for anyone who is interested in learning!</p>
    </div>
}

function FestivalInfoSection(props) {
  return <section className="m-0 pt-5" id="festivalInfo">
    <Container>
      <h2 className="display-2 mb-5">Festival Info</h2>
      <EventsSchedule schedule={props.schedule} />
      <Locations />
      <Row className="mt-5">
        <Col md="6" className="mb-3">
          <Games games={props.games} />
        </Col>
        <Col md="6" className="mb-3">
          <Workshops />
        </Col>
        <Col md="12" className="mb-3">
          <Accomodations accomodations={props.accomodations} />
        </Col>
      </Row>
    </Container>
  </section>
}

function SponsorsSection() {
  return <section className="m-0 pt-5" id="sponsors">
    <Container>
      <h2 className="display-2 mb-5">Sponsors</h2>
      <p className="lead text-secondary">A huge thank you to our sponsors and supporters:</p>
      <p>Karen Phillips, Daniel Holzman, Higgins Brothers, Flying Clipper, Jolly Lama, Home of Poi, flowtoys, Shiva's Delight, and The Haunted Walk.</p>
      <p>Find raffle prizes and more from these lovely folks at the festival!</p>
      <Row className="my-5">
        <Col xs={6}  lg={3} className="d-flex align-items-center justify-content-center p-2 p-md-3">
          <Image src={sponsorImageFlyingClipper} fluid/>
        </Col>
        <Col xs={6}  lg={3} className="d-flex align-items-center justify-content-center p-2 p-md-r">
          <Image src={sponsorImageHop} fluid/>
        </Col>
        <Col xs={6}  lg={3} className="d-flex align-items-center justify-content-center p-2 p-md-3">
          <Image src={sponsorImageJolly} fluid/>
        </Col>
        <Col xs={6}  lg={3} className="d-flex align-items-center justify-content-center p-2 p-md-3">
          <Image src={sponsorImageFlowtoys} fluid/>
        </Col>
        <Col xs={6}  lg={3} className="d-flex align-items-center justify-content-center p-2 p-md-3">
          <Image src={sponsorImageHauntedWalk} fluid/>
        </Col>
        <Col xs={6}  lg={3} className="d-flex align-items-center justify-content-center p-2 p-md-3">
          <Image src={sponsorImageShivas} fluid/>
        </Col>
      </Row>
    </Container>
  </section>
}

export default function Home(props) {
  return <div className="bg-light">
    <HeroSection />
    <AboutSection />
    <FestivalInfoSection {...props} />
    <SponsorsSection />
    <FaqsSection faqs = { props.faqs}/>
  </div>
}
